import HandDislikeIcon from "../images/HandDislikeIcon.mjs";

/**
 * App icon for "false" (failing) boolean values, highlighted in danger color
 * @see {GlyphIcon}
 * @see {HandDislikeIcon}
 */
const AppFlagFalseIcon = class extends HandDislikeIcon {
	constructor(props) {
		super(props);
		this.state.fill = "var(--danger-color)";
	}
}

export default AppFlagFalseIcon;